/**
 * Útvonalak az App.js router szerint (/szolgaltatas/...).
 * Canonical URL-ek a getPageSeo() építi SITE_ORIGIN alapján.
 */
export const seoConfig = {
  home: {
    path: '/',
    title: 'Move And Parcel - Szállítmányozás',
    description:
      'Nagyméretű csomag, IKEA bútor, raklapos áru, kerékpár és költöztetés belföldön és Európán belül. Kérj gyors ajánlatot!',
    ogTitle: 'Move and Parcel – Nagyméretű csomag és bútorszállítás',
    ogDescription:
      'IKEA szállítás, nagyméretű csomag, bútorszállítás, költöztetés és raklapos fuvarozás.',
  },

  ikea: {
    path: '/szolgaltatas/ikea-hazhozszallitas',
    title: 'IKEA házhozszállítás és bútorszállítás – Move and Parcel',
    description:
      'IKEA, Möbelix vagy XXXLutz bútor szállítása Budapestről vidékre vagy házhoz. Nagyméretű bútorokhoz és egyedi igényekhez is.',
  },

  nagyCsomag: {
    path: '/szolgaltatas/csomagszallitas',
    title: 'Nagyméretű csomag szállítás – XXL futár háztól házig | Move and Parcel',
    description:
      'Nagy, nehéz vagy túlméretes csomagot küldenél? XXL csomagszállítás háztól házig, belföldön és nemzetközi viszonylatban is.',
  },

  butorszallitas: {
    path: '/szolgaltatas/butor-szallitas',
    title: 'Bútorszállítás biztonságosan – Move and Parcel',
    description:
      'Bútorszállítás, antik bútor, műtárgy, tükör és sérülékeny tárgyak szállítása. Igény szerint rakodási segítséggel.',
  },

  kerekpar: {
    path: '/szolgaltatas/kerekpar-szallitas',
    title: 'Kerékpár szállítás futárral – Move and Parcel',
    description:
      'Kerékpár szállítás futárral, bicikli feladása csomagként, belföldön és külföldre is. Egyedi ajánlattal.',
  },

  koltoztetes: {
    path: '/szolgaltatas/koltoztetes',
    title: 'Költöztetés belföldön és külföldre – Move and Parcel',
    description:
      'Belföldi és nemzetközi költöztetés, bútorszállítás, részrakomány és komplett fuvar. Kérj ajánlatot pontos méret és cím alapján!',
  },

  raklap: {
    path: '/szolgaltatas/raklapos-szallitas',
    title: 'Raklapos szállítás belföldön és külföldre | Move and Parcel',
    description:
      'Raklapos áru szállítása belföldön és nemzetközi viszonylatban. Részrakomány, komplett fuvar, gépi rakodásra előkészített áruk.',
  },

  gyik: {
    path: '/gyik',
    title: 'Gyakori kérdések – Move and Parcel',
    description: 'Válaszok csomagszállításról, költöztetésről, IKEA és nemzetközi fuvarokról. Move and Parcel.',
  },

  rolunk: {
    path: '/rolunk',
    title: 'Rólunk – Move and Parcel',
    description:
      'Belföldi és nemzetközi szállítmányozás, egyedi igényekre. Ismerd meg a Move and Parcel csapatát és értékeit.',
  },

  privacy: {
    path: '/adatkezelesi-tajekoztato',
    title: 'Adatkezelési tájékoztató – Move and Parcel',
    description: 'Adatkezelési tájékoztató a Move and Parcel weboldalához és szolgáltatásaihoz.',
  },

  ajanlat: {
    path: '/ajanlat',
    title: 'Ajánlatkérés – Move and Parcel',
    description:
      'Kérj személyre szabott ajánlatot csomagszállításra, költöztetésre, IKEA vagy raklapos fuvarra. Gyors válasz.',
  },

  notFound: {
    title: '404 – Az oldal nem található | Move and Parcel',
    description: 'A keresett oldal nem létezik. Vissza a főoldalra vagy ajánlatkéréshez.',
    robots: 'noindex, follow',
  },

  /** Bejelentkezés, admin — nem indexelendő */
  auth: {
    title: 'Move and Parcel',
    description: '',
    robots: 'noindex, nofollow',
  },

  vegleges: {
    title: 'Megrendelés – Move and Parcel',
    description: '',
    robots: 'noindex, nofollow',
  },
};

/** Ajánlat űrlap útvonalak: /ajanlat/{slug} */
export const seoQuoteByServiceSlug = {
  'ikea-hazhozszallitas': {
    title: 'IKEA szállítás – ajánlatkérés | Move and Parcel',
    description:
      'Kérj ajánlatot IKEA és nagyméretű bútor szállításra. Házhozszállítás, vidék, nemzetközi viszonylat.',
  },
  csomagszallitas: {
    title: 'Nagyméretű csomag – ajánlatkérés | Move and Parcel',
    description: 'XXL és nehéz csomag ajánlatkérése. Háztól házig szállítás belföldön és EU-ban.',
  },
  'butor-szallitas': {
    title: 'Bútorszállítás – ajánlatkérés | Move and Parcel',
    description: 'Egyedi bútorszállítás ajánlatkérése. Antik, sérülékeny tételek gondos kezeléssel.',
  },
  'kerekpar-szallitas': {
    title: 'Kerékpár szállítás – ajánlatkérés | Move and Parcel',
    description: 'Kerékpár és motorkerékpár szállításra kérj ajánlatot futárszolgálattal.',
  },
  koltoztetes: {
    title: 'Költöztetés – ajánlatkérés | Move and Parcel',
    description: 'Költöztetés és bútorszállítás ajánlatkérése. Belföld és külföld.',
  },
  'raklapos-szallitas': {
    title: 'Raklapos szállítás – ajánlatkérés | Move and Parcel',
    description: 'Raklapos áru fuvarozására kérj ajánlatot. Részrakomány és teljes rakomány.',
  },
};
